import { render, staticRenderFns } from "./DataHub.vue?vue&type=template&id=726bbeb6&lang=pug"
import script from "./DataHub.vue?vue&type=script&lang=js"
export * from "./DataHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports